// Validação de CPF (dígitos verificadores) — recebe string com ou sem máscara.

function digitoVerificador(base: string, peso: number): number {
  const soma = base
    .split('')
    .reduce((acc, d, i) => acc + Number(d) * (peso - i), 0)
  const resto = (soma * 10) % 11
  return resto === 10 ? 0 : resto
}

export function validarCPF(cpf: string): boolean {
  const digitos = cpf.replace(/\D/g, '')
  if (digitos.length !== 11) return false
  if (/^(\d)\1{10}$/.test(digitos)) return false // todos os dígitos iguais

  const d1 = digitoVerificador(digitos.slice(0, 9), 10)
  const d2 = digitoVerificador(digitos.slice(0, 10), 11)
  return d1 === Number(digitos[9]) && d2 === Number(digitos[10])
}
